import { useQuery } from 'react-query';
import { getFeatureFlags } from './api';
import { FeatureFlagsRequestData } from './types';

export const useFeatureFlagsQuery = (
  featureFlagsRequestData: FeatureFlagsRequestData
) => {
  return useQuery(
    ['featureFlags', featureFlagsRequestData],
    () => getFeatureFlags(featureFlagsRequestData),
    {
      staleTime: 30 * 60 * 1000 // 30mins
    }
  );
};
